import React from 'react';
const SvgCopy: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.006 12.003L17 15.001l-3 3.002M9 15H5a2 2 0 01-2-2V5a2 2 0 012-2h8a2 2 0 012 2v4"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 21h-8a2 2 0 01-2-2v-8a2 2 0 012-2h8a2 2 0 012 2v8a2 2 0 01-2 2zM9 15h8"
      />
    </svg>
  );
};
export default SvgCopy;
